export const ACTIVITY_SUMMARY_DEFAULT_PERIOD_DAYS = 90 as const

export const ACTIVITY_SUMMARY_SCORE_NORMALIZATION = {
  reservationsCap: 300,
  ticketsCap: 600,
  guestlistsCap: 400,
  tallyCap: 300,
  paymentLinksCap: 150,
  leadsCap: 300,
  totalCustomersCap: 1000,
  subscriptionActiveBonus: 10,
} as const

export const ACTIVITY_SUMMARY_SCORE_WEIGHTS = {
  reservations: 20,
  tickets: 15,
  guestlists: 10,
  tally: 8,
  paymentLinks: 20,
  leads: 7,
  totalCustomers: 20,
} as const
